module.exports = __webpack_public_path__ + "media/images/flags/MQ-17d2365dfa0d7bc2d1896578ef74d35d.svg";